import styled from 'styled-components';
import { FlexBoxRow } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';

export const Wrapper = styled.div`
    width: 100%;
    padding: 20px 0;
    flex-direction: column;
`;

export const Blocks = styled.div`
    display: ${props => props.isFlex ? 'flex' : 'block'};
`;

export const OffersRow = styled(FlexBoxRow)`
    width: 100%;
`;

export const getMarginByIndex = ({ index, offersInRow, bannerInfo = {} }) => {
    const isBannerExists = Object.keys(bannerInfo).length > 0;
    let leftMargin = (index % offersInRow === 0) ? '0' : '1%';

    // если есть баннер, то все подарки смещаются
    if (isBannerExists) {
        leftMargin = (index + 1) % offersInRow === 0
            ? '0'
            : '1%';

        if (offersInRow === 3 &&
            (index === 2 || index === 5)) {
            leftMargin = '0';
        }

        if (offersInRow === 2 &&
            (index === 1 || index === 3 || index === 5)) {
            leftMargin = '0';
        }
    }

    if (offersInRow === 1) {
        leftMargin = '0';
    }

    const rightMargin = (index + 1) % offersInRow === (offersInRow - 1)
        ? '0'
        : '1%';

    return `0 ${rightMargin} 20px ${leftMargin}`;
};
